import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
// import MediaIntroSection from '../components/MediaIntroSection';
import Solutions from '../components/Solutions';
import Stats from '../components/Stats';
import ScaleCards from '../components/ScaleCards';
import Partners from '../components/Partners';
import WhyChooseUs from '../components/WhyChooseUs';
import CompactPartners from '../components/CompactPartners';
import Reviews from '../components/Reviews';
import HomeFAQs from '../components/HomeFAQs';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEOHead from '../seo/SEOHead';
import JsonLd from '../seo/JsonLd';
import { organizationSchema, webSiteSchema, softwareApplicationSchema, createReviewSchema } from '../seo/schemas';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

const Home = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const reviewsData = [
    { name: t.review1Name, text: t.review1Text, date: '2026-01-05', rating: 5 },
    { name: t.review2Name, text: t.review2Text, date: '2025-12-01', rating: 5 },
    { name: t.review3Name, text: t.review3Text, date: '2025-11-15', rating: 5 },
  ];

  return (
    <>
      <SEOHead />
      <JsonLd data={organizationSchema} />
      <JsonLd data={webSiteSchema} />
      <JsonLd data={softwareApplicationSchema} />
      <JsonLd data={createReviewSchema(reviewsData)} />
      <main className="min-h-screen">
        <div className="pt-16">
          <Hero />
          <Partners />
          <Stats />
          <ScaleCards />
          <Solutions />
          <Features />
          {/* <MediaIntroSection /> */}
          <WhyChooseUs />
          <CompactPartners />
          <Reviews />
          <HomeFAQs />
          <CTASection />
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Home;
